var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8794 10.9805L15.6745 8.78908C15.8757 8.67267 16 8.45681 16 8.22512V3.84227C16 3.61058 15.8757 3.39472 15.6745 3.27831L11.8794 1.08688C11.6782 0.970474 11.4284 0.971605 11.2284 1.08688L7.43321 3.27831C7.23204 3.39472 7.10772 3.61058 7.10772 3.84227V11.6744L4.44614 13.2104L1.78456 11.6744V8.60147L4.44614 7.06555L6.20131 8.07933V6.01787L4.77163 5.19171C4.67331 5.1352 4.56029 5.10468 4.44614 5.10468C4.33199 5.10468 4.21897 5.1352 4.12065 5.19171L0.325493 7.38313C0.12432 7.49954 0 7.71541 0 7.94709V12.3299C0 12.5616 0.12432 12.7775 0.325493 12.8939L4.12065 15.0853C4.32182 15.2006 4.57046 15.2006 4.77163 15.0853L8.56679 12.8939C8.76796 12.7775 8.89228 12.5616 8.89228 12.3299V4.49778L8.93975 4.47065L11.5527 2.96186L14.2143 4.49778V7.57074L11.5527 9.10666L9.79982 8.09515V10.1566L11.2272 10.9805C11.4284 11.0958 11.6782 11.0958 11.8782 10.9805H11.8794Z",
    fill: "url(#paint0_linear_47_218)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_218",
    x1: -0.0519884,
    y1: 12.7605,
    x2: 15.3117,
    y2: 3.84227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A726C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#803BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B3FE4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.d6d490a048521c04a7b3d8f04184337f.svg";
export { ForwardRef as ReactComponent };